export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-usb-1b30273b4e37e8b769e57d5b51923a51.svg";